<ul class="nav">
    <ng-template ngFor let-navitem [ngForOf]="navItems">
        <div *ngIf="isVisible(navitem)">
            <li *ngIf="!isHasChild(navitem)"
                [ngClass]="{'nav-title': isTitle(navitem), 'nav-item': !(isTitle(navitem))}">
                <span *ngIf="isTitle(navitem)">{{navitem.name}}</span>
                <a class="nav-link" *ngIf="!(isTitle(navitem))" [routerLink]="getRouterLink(navitem)"
                   routerLinkActive="active">
                    <i class="nav-icon" [ngClass]="navitem.icon"></i> {{navitem.name}}
                </a>
            </li>
            <li *ngIf="isHasChild(navitem)" appNavDropdown routerLinkActive="open" class="nav-item nav-dropdown">
                <a appNavDropdownToggle _ngcontent-c4 class="nav-link-child-title nav-link nav-dropdown-toggle" role="button">
                    <i class="nav-icon" [ngClass]="navitem.icon"></i> {{navitem.name}}
                </a>
                <ul class="nav-dropdown-items">
                    <li class="nav-item" *ngFor="let cnavitem of navitem.children">
                        <a class="nav-link-child nav-link" *ngIf="!(isTitle(cnavitem)) && isVisible(cnavitem)"
                           [routerLink]="getRouterLink(cnavitem)" [routerLinkActiveOptions]="{exact:false}"
                           routerLinkActive="active">
                            <i class="nav-icon" [ngClass]="cnavitem.icon"></i> {{cnavitem.name}}
                        </a>
                    </li>
                </ul>
            </li>
        </div>
    </ng-template>
</ul>
